export default "__VITE_ASSET__DNMbwx4S__"